/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Help_ArticlesInputs */



/**
* | output |
* | --- |
* | "Help articles" |
*
* @param {Layout_Header_Help_ArticlesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_help_articles = /** @type {((inputs?: Layout_Header_Help_ArticlesInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Help_ArticlesInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hilfeartikel")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Articles d'aide")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("帮助文章")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("說明文章")
	if (locale === "ko") return /** @type {LocalizedString} */ ("도움말 문서")
	return /** @type {LocalizedString} */ ("Help articles")
});